import React, { useContext } from 'react';
import { HeaderStyled } from './styles';
import { GiHamburgerMenu } from "react-icons/gi";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { FaTimes } from "react-icons/fa";
import { MdLogout } from "react-icons/md";

import { ContentContext } from '../../../context';

const Header = (props) => {

    const { logout,
            isLoged } = useContext(ContentContext);

    const { showNav, setShowNav } = props;

    const handleMenu = () => {
        setShowNav(!showNav);
    }

    return (
        <HeaderStyled>
            
            <div className='inner'>
                <div className={`bt_menu${showNav ? " open" : " close"}`} onClick={handleMenu}>
                    {!showNav ?
                        <GiHamburgerMenu />
                    :
                        <FaTimes />
                    }
                </div>
                {isLoged ?
                <div className='bt_logout' onClick={logout}>
                    <MdLogout />
                </div> : "" }
            </div>
            
        </HeaderStyled>
    );
};

export default Header;